module.exports = __webpack_public_path__ + "static/media/023-online payment.e54eeb2e.png";